export default __webpack_public_path__ + "static/media/background_detail.227a7549.png";